import {Dialog, DialogContent, DialogTitle, Divider, IconButton, Typography, Stack} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment-timezone';
import {useTranslation} from 'react-i18next';

import AmendmentCard from './AmendmentCard';
import {FULL_DAY_DATE_FORMAT} from '../../config/DateTimeConstants';
import {useCurrentUser} from '../../hooks/useCurrentUser';

const styles = {
    dialog: {
        closeButton: {
            color: (theme) => theme.palette.grey[500],
            position: 'absolute',
            right: 20,
            top: 12,
        },
        content: {
            padding: '1rem',
        },
    },
};

export default function AmendmentsDialog({open, onClose, selectedAmendmentRow, timezone}) {
    const {currentUser} = useCurrentUser();
    const {t} = useTranslation();
    const title = `${currentUser?.givenName} ${currentUser?.familyName}`;
    const {
        time: shiftTimeRange = '',
        date = '',
        services = [],
        amendments = [],
    } = selectedAmendmentRow ?? {};

    const dateLabel = date ? moment(date).format(FULL_DAY_DATE_FORMAT) : '';
    const servicesLabel = `(${services.filter(Boolean).join(' + ')})`;
    const amendmentCountLabel = t('common.amendmentCountLabel', {count: amendments.length});

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth>
            <DialogTitle>
                <Typography variant="h5" fontWeight={700}>
                    {title}
                </Typography>

                <Typography color="text.secondary">
                    {dateLabel} · {amendmentCountLabel}
                </Typography>
            </DialogTitle>

            <IconButton aria-label="close" onClick={onClose} sx={styles.dialog.closeButton}>
                <CloseIcon/>
            </IconButton>

            <Divider sx={{borderColor: 'grey.300'}}/>

            <DialogContent sx={styles.dialog.content}>
                <Stack spacing={2}>
                    {amendments.map((amendment) => (
                        <AmendmentCard
                            key={amendment.id}
                            amendment={amendment}
                            shiftTimeRange={shiftTimeRange}
                            servicesLabel={servicesLabel}
                            timezone={timezone}/>
                    ))}
                </Stack>
            </DialogContent>
        </Dialog>
    );
}
